import {Component} from '@angular/core';
import {Days, TimeSlot} from '../../store/entities';
import {combineLatest, Observable, of} from 'rxjs';
import {IScheduleState} from '../../store/reducers/schedule.reducer';
import {NgRedux, Select} from '@angular-redux3/store';
import {map, switchMap, tap} from 'rxjs/operators';
import {getCurrentDay} from '../../utils';
import {ASetDay, PlaylistRemoteAppState} from '../../store';
import {Router} from '@angular/router';

@Component({
  selector: 'mwo-scheduler-modifier',
  templateUrl: './scheduler-modifier.component.html',
  styleUrls: ['./scheduler-modifier.component.scss']
})
export class SchedulerModifierPage {

  day: Days;
  activeDay$: Observable<string> = this.ngRedux.select('activeDay');
  schedule$: Observable<IScheduleState> = this.ngRedux.select('schedule');
  @Select('scheduleDay') schedule24$: Observable<TimeSlot>;
  @Select(['player', 'playerContextType']) context$: Observable<string>;
  @Select(['player', 'isPlaying']) isPlaying$: Observable<boolean>;
  @Select(['remote', 'name']) remoteName$: Observable<string>;
  @Select(['player', 'timeSlot']) currentSlot$: Observable<TimeSlot>;

  slots$: Observable<TimeSlot[]> = combineLatest([this.schedule$, this.activeDay$]).pipe(
    map(([schedule, day]) => (schedule[day] || {}).slots || []),
  );

  // @ts-ignore
  isPlayingFromSchedule$: Observable<boolean> = this.context$.pipe(
    tap((context) => console.log('context', context)),
    switchMap(context => {
      if (context === 'SCHEDULE_WEEKLY') {
        return this.isPlaying$;
      } else if (context === 'PLAYLIST') {
        return of(false);
      } else {
        return of(false);
      }
    }),
  );

  isCurrentDaySelected$: Observable<boolean> = this.activeDay$.pipe(
    map(activeDay => activeDay === getCurrentDay() || activeDay === Days.ALLDAY)
  );

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private router: Router
  ) { }

  onActiveDayChanged(day: Days = getCurrentDay()) {
    this.ngRedux.dispatch(ASetDay(day));
    this.day = day;
  }

  openDuplicateInterface() {
    this.router.navigate(['duplicate-page'])
  }

  openModifyInterface() {
    this.router.navigate(['edit-scheduler-page'])
  }

  back() {
    this.router.navigate(['scheduler'])
  }
}
